/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, August 14th 2022, 8:27:27 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { useWorkflowContext } from "service-builder/providers";
import { useDeleteTaskTemplate } from "service-builder/services";
import { DeleteOSItemDialog } from "version-control/components/DeleteOSItemDialog";

interface DeleteTaskTemplateComponentProps {
  openDelete: boolean;
  handleCloseDelete: () => void;
}

export const DeleteTaskTemplateComponent = ({ openDelete, handleCloseDelete }: DeleteTaskTemplateComponentProps) => {
  const {
    taskTemplateListContext: { updateListAndSelectIfNewItem, currentMutationItem, removeItem },
  } = useWorkflowContext();

  return (
    <DeleteOSItemDialog<TaskTemplate>
      useDeleteOSItem={useDeleteTaskTemplate}
      itemId={currentMutationItem?.id}
      onDelete={() => removeItem(currentMutationItem?.id)}
      openDialog={openDelete}
      handleCloseDialog={handleCloseDelete}
      onRestore={updateListAndSelectIfNewItem}
    />
  );
};
